
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import selectControlComponent from './select-control.component';

let selectControlModule = angular.module('select-control', [
  uiRouter
])

.component('selectControl', selectControlComponent)

.name;

export default selectControlModule;



// WEBPACK FOOTER //
// ./client/app/common/select-control/select-control.js